import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/auth/auth.service';
import { Fatura } from 'src/model/fatura';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-fatura-liste',
  templateUrl: './fatura-liste.component.html',
  styleUrls: ['./fatura-liste.component.css'],
})
export class FaturaListeComponent implements OnInit {
  DURUM_ONAY_SURECI = Fatura.DURUM_ONAY_SURECI;

  faturalar: Fatura[] = null;
  userGrupId: number;
  showAktarildiIsaretleModalTs: number = null; // farklı id verince açılıyor.
  faturaId: number;

  @Output() updateList = new EventEmitter<boolean>();

  @Input()
  public set source(faturalar: Fatura[]) {
    if (faturalar != null) {
      this.faturalar = faturalar.map((item) => {
        item.toplamTutar = this.moneyFormat(item.toplamTutar, 2, 3, '.', ',');
        return item;
      });
    }
  }

  constructor(
    private router: Router,
    private restService: RestService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.userGrupId = this.authService.getUser().kullaniciGrupId;
  }

  incele(f: Fatura) {
    this.router.navigate(['fatura'], { queryParams: { id: f.id } });
  }

  netsiseAktar(id: number) {
    this.restService.netsisFaturaAktar(id).subscribe((res) => {
      if (!res) {
        this.updateList.emit(true);
      } else {
        this.faturaId = id;
        this.showAktarildiIsaretleModalTs = new Date().getTime();
      }
    });
  }

  iptalEt(id: number) {
    if (confirm('İptal etmek istediğinizden emin misiniz?')) {
      this.restService.faturaSil(id).subscribe((res) => {
        if (res) {
          this.updateList.emit(true);
        }
      });
    }
  }

  iptalEdilebilir(f: Fatura): boolean {
    let ret: boolean;
    if (!f.netsiseIslendi && f.durum !== 2) {
      ret = true;
      if (f.durum === 1 && this.userGrupId !== 7) {
        ret = false;
      } //yönetici
    }

    return ret;
  }

  updateLists() {
    this.updateList.emit(true);
  }

  moneyFormat(value, n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
      num = value.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(
      new RegExp(re, 'g'),
      '$&' + (s || ',')
    );
  }
}
